import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './App.css';
import Root from './routes/root';
import Transactions from './routes/transactions';
import TransactionDetail from './routes/transaction-detail';
import Authenticate from './routes/authenticate';
import Protected from './components/Protected';
import { AuthProvider } from './context/AuthContext';
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev';

loadDevMessages();
loadErrorMessages();

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Protected>
        <Root />
      </Protected>
    )
  },
  {
    path: '/auth/login',
    element: <Authenticate />
  },
  {
    path: '/transactions',
    element: (
      <Protected>
        <Transactions />
      </Protected>
    )
  },
  {
    path: '/transactions/:transactionId',
    element: (
      <Protected>
        <TransactionDetail />
      </Protected>
    )
  }
]);

function App() {
  return (
    <div className='App'>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </div>
  );
}

export default App;
